import { render, staticRenderFns } from "./CollectPoint.vue?vue&type=template&id=19ebc981&scoped=true&"
import script from "./CollectPoint.vue?vue&type=script&lang=js&"
export * from "./CollectPoint.vue?vue&type=script&lang=js&"
import style0 from "./CollectPoint.vue?vue&type=style&index=0&id=19ebc981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ebc981",
  null
  
)

export default component.exports